<script lang="ts">
	import type { ComponentProps } from 'svelte';
	import Badge from '$lib/components/atoms/badge/Badge.svelte';
	import PoiImage from '../../image/PoiImage.svelte';
	import PoiCardCarousel from '../poiCardCarousel/PoiCardCarousel.svelte';
	import PriceTag from '../poiCardPriceTag/PoiCardPriceTag.svelte';

	interface Props {
		image?: Exclude<ComponentProps<typeof PoiImage>, 'class'>;
		carousel?: ComponentProps<typeof PoiCardCarousel>;
		badge?: ComponentProps<typeof Badge>;
		priceTag?: ComponentProps<typeof PriceTag>;
	}

	const { image, carousel, badge, priceTag }: Props = $props();

	const wrapperTag = image ? 'figure' : 'div';
</script>

<svelte:element this={wrapperTag} data-testid="poi-card-hero" class="poi-card-hero group grid w-full h-full max-h-132px p-0 m-0 overflow-hidden">
	{#if image}
		<PoiImage {...image} class="image h-full w-full grid-area-[1/-1] rd-tr-2 rd-tl-2" />
	{:else if carousel}
		<PoiCardCarousel
			{...carousel}
			containerClasses="carousel h-full max-h-132px w-full grid-area-[1/-1] "
			carouselClasses="rd-tr-2 rd-tl-2"
			controlsClasses="poi-card-hero-controls"
		/>
	{/if}
	{#if badge}
		<div class="relative self-start justify-self-end grid-area-[1/-1] p-2 group-has-hover:opacity-0">
			<Badge {...badge} />
		</div>
	{/if}
	{#if priceTag}
		<div class="relative self-end grid-area-[1/-1] p-2 group-has-hover:opacity-0">
			<PriceTag {...priceTag} />
		</div>
	{/if}
</svelte:element>

<style>
	.poi-card-hero:hover :global(.right-arrow-container),
	.poi-card-hero:hover :global(.left-arrow-container) {
		visibility: visible;
	}
	.poi-card-hero :global(.right-arrow-container),
	.poi-card-hero :global(.left-arrow-container) {
		visibility: hidden;
	}
</style>
